export default __webpack_public_path__ + "static/media/Weather1.a4d5258b.png";